import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type RevokePartnerInviteInput = {
  partnerId: string;
  partnerUserId: string;
};

// POST /api/partners/:id/users/:userId/revoke
//
// Marks all pending invites for this partner_user as expired. The
// partner_user row stays; the UI shows "Expired" status next to it.
export function useRevokePartnerInvite() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, RevokePartnerInviteInput>({
    mutationFn: ({ partnerId, partnerUserId }) =>
      apiFetch<{ ok: true }>(`/partners/${partnerId}/users/${partnerUserId}/revoke`, {
        method: "POST",
      }),
    onSuccess: (_data, { partnerId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.users(partnerId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to revoke invite");
    },
  });
}
